(function () {
  const ERROR_CLASS = 'klaviyo-form-consent-error';
  const ERROR_MESSAGE = 'Please agree to SMS marketing to continue.';

  function isPhoneComplete(phone) {
    const digits = phone.value.replace(/\D/g, '');
    return digits.length >= 10;
  }

  function needsConsent(phone, optIn) {
    return isPhoneComplete(phone) && !optIn.checked;
  }

  function isConsentField(target) {
    return (
      target.matches('input[type="tel"]') ||
      target.matches('input[type="checkbox"]')
    );
  }

  function getRoot(node) {
    const root = node.closest('[class^="klaviyo-form-"]');
    if (!root) return null;
    if (root.classList.contains('klaviyo-form-RJgTUZ')) return root;
    if (root.closest('[data-yotpo-sms-tile]')) return root;
    return null;
  }

  function getConsentRow(optIn) {
    return (
      optIn.closest('form > div > div') ||
      optIn.closest('label')?.parentElement
    );
  }

  function getErrorElement(optIn) {
    const row = getConsentRow(optIn);
    const root = getRoot(optIn);
    if (!row || !root) return null;

    let error = root.querySelector(`.${ERROR_CLASS}`);

    if (!error) {
      error = document.createElement('p');
      error.className = ERROR_CLASS;
      error.setAttribute('role', 'alert');
      error.textContent = ERROR_MESSAGE;
      error.hidden = true;
      row.insertAdjacentElement('afterend', error);
    } else if (error.previousElementSibling !== row) {
      row.insertAdjacentElement('afterend', error);
    }

    return error;
  }

  function showError(optIn) {
    const error = getErrorElement(optIn);
    if (!error) return;
    error.hidden = false;
    optIn.setAttribute('aria-invalid', 'true');
  }

  function clearError(optIn) {
    const root = getRoot(optIn);
    const error = root?.querySelector(`.${ERROR_CLASS}`);
    if (error) error.hidden = true;
    optIn.removeAttribute('aria-invalid');
  }

  function sync(root) {
    const phone = root.querySelector('input[type="tel"]');
    const optIn = root.querySelector('input[type="checkbox"]');
    if (!phone || !optIn) return;

    if (needsConsent(phone, optIn)) {
      showError(optIn);
      return;
    }
    clearError(optIn);
  }

  function bind(root) {
    if (root.dataset.consentBound) return;

    const phone = root.querySelector('input[type="tel"]');
    const optIn = root.querySelector('input[type="checkbox"]');
    if (!phone || !optIn) return;

    root.dataset.consentBound = '1';

    root.addEventListener(
      'input',
      (event) => {
        if (!isConsentField(event.target)) return;
        sync(root);
      },
      true
    );

    root.addEventListener(
      'change',
      (event) => {
        if (!isConsentField(event.target)) return;
        sync(root);
      },
      true
    );

    sync(root);
  }

  function scan() {
    document.querySelectorAll('.klaviyo-form-RJgTUZ').forEach(bind);
    document.querySelectorAll('[data-yotpo-sms-tile] [class^="klaviyo-form-"]').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('klaviyoForms', scan);
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
